import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import { TrackedEvent, trackEvent } from "@/domains/metrics";
import { MdsLink } from "@/mds/components/link";
import { MDSSection, MDSSectionSlotName } from "@/mds/components/section";
import { windowModule } from "@/modules/window";
import { ApiKeyItemList } from "@/pages/integrations/api/integrations-api-page-content-list";
import { IntegrationsLayoutBottomBuffer } from "@/pages/integrations/shared/integrations-layout";
import {
  StyledContentList,
  StyledContentSectionTitleWrapper,
  StyledContentStatusWrapper,
  StyledContentWrapper,
} from "@/pages/integrations/shared/integrations.styles";
import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";

import { FC, useCallback } from "react";

export const IntegrationsApiPageContent: FC = observer(() => {
  const { store } = useAppStore();
  const isConnected = store.apiKeys.allActiveApiKeys.length > 0;

  const handleClickDevDocsLink = useCallback(() => {
    trackEvent(TrackedEvent.ApiDevDocsLinkClick);
    windowModule.openInNewTab({ url: new URL("https://docs.mem.ai") });
  }, []);

  return (
    <StyledContentWrapper>
      <MDSSection
        title={
          <StyledContentSectionTitleWrapper>
            <MdsIcon kind={MdsIconKind.Merge} />
            API Integration
          </StyledContentSectionTitleWrapper>
        }
      >
        <div slot={MDSSectionSlotName.HeaderRightAddon}>
          {isConnected && (
            <StyledContentStatusWrapper>
              Connected
              <MdsIcon kind={MdsIconKind.CheckCircleSolid} />
            </StyledContentStatusWrapper>
          )}
        </div>
        <StyledContentList>
          <li>API keys help you connect Mem with other apps and services you use.</li>
          <li>
            Whether you&apos;re building custom integrations or using third-party tools, our{" "}
            <DevDocsLink onClick={handleClickDevDocsLink}>API Docs</DevDocsLink> will guide you
            through the process.
          </li>
          <li>Remember to treat your API keys like passwords - keep them private and secure.</li>
        </StyledContentList>
      </MDSSection>
      <ApiKeyItemList />
      <IntegrationsLayoutBottomBuffer />
    </StyledContentWrapper>
  );
});

const DevDocsLink = styled(MdsLink)(({ theme }) => ({
  fontWeight: theme.fontWeights.medium,
}));
